"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/stepper.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Step = function Step(_ref) {
  var _classnames, _classnames2;

  var children = _ref.children,
      main = _ref.main,
      onChange = _ref.onChange,
      step = _ref.step,
      theme = _ref.theme;
  var status = step.status;
  var circleClasses = (0, _classnames3.default)((_classnames = {
    'vn-stepper__main-circle': main
  }, _defineProperty(_classnames, "vn-stepper__main-circle-".concat(theme, "--").concat(status), main), _defineProperty(_classnames, 'vn-stepper__secondary-circle', !main), _defineProperty(_classnames, "vn-stepper__secondary-circle-".concat(theme, "--").concat(status), !main), _classnames));
  var labelClasses = (0, _classnames3.default)({
    'vn-stepper__main-label': main,
    'vn-stepper__secondary-label': !main
  });
  var titleClasses = (0, _classnames3.default)((_classnames2 = {
    'vn-stepper__main-title': main
  }, _defineProperty(_classnames2, "vn-stepper__main-title-".concat(theme), main), _defineProperty(_classnames2, "vn-stepper__main-title-".concat(theme, "--").concat(status), main), _defineProperty(_classnames2, 'vn-stepper__secondary-title', !main), _defineProperty(_classnames2, "vn-stepper__secondary-title-".concat(theme), !main), _defineProperty(_classnames2, "vn-stepper__secondary-title-".concat(theme, "--").concat(status), !main), _classnames2));
  var wrapperClasses = (0, _classnames3.default)({
    'vn-stepper__main-wrapper': main,
    'vn-stepper__secondary-wrapper': !main
  });
  return _react.default.createElement("div", {
    className: main ? 'vn-stepper__main' : 'vn-stepper__secondary'
  }, _react.default.createElement("div", {
    "aria-label": step.title,
    className: circleClasses,
    onClick: onChange,
    onKeyDown: function onKeyDown() {},
    role: "button",
    tabIndex: "0"
  }, main && status === 'complete' && _react.default.createElement(_icon.default, {
    name: "checkmark",
    size: 32
  }), main && status === 'start' && _react.default.createElement(_icon.default, {
    className: "vn-stepper__main-icon--start",
    name: "chevron",
    size: 32
  }), main && status !== 'complete' && status !== 'start' && step.step), _react.default.createElement("div", {
    className: wrapperClasses
  }, _react.default.createElement("div", {
    className: titleClasses
  }, step.title && _react.default.createElement("span", {
    className: labelClasses
  }, step.title), step.description && _react.default.createElement("span", {
    className: "vn-stepper__main-description"
  }, step.description)), !step.show && children, step.content && step.show && _react.default.createElement("div", {
    className: "vn-stepper__content"
  }, step.content)));
};

Step.propTypes = {
  children: _propTypes.default.element,
  main: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  step: _propTypes.default.shape({
    content: _propTypes.default.node,
    description: _propTypes.default.string,
    show: _propTypes.default.bool,
    status: _propTypes.default.oneOf(['complete', 'disabled', 'incomplete', 'ongoing', 'start']).isRequired,
    step: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    steps: _propTypes.default.arrayOf(_propTypes.default.shape({
      content: _propTypes.default.node,
      status: _propTypes.default.oneOf(['complete', 'disabled', 'incomplete', 'ongoing']).isRequired,
      step: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
      title: _propTypes.default.string
    })),
    title: _propTypes.default.string
  }),
  theme: _propTypes.default.oneOf(['dark', 'light'])
};
Step.defaultProps = {
  children: undefined,
  main: false,
  onChange: function onChange() {},
  step: undefined,
  theme: 'light'
};

var Stepper = function Stepper(_ref2) {
  var _onChange = _ref2.onChange,
      steps = _ref2.steps,
      theme = _ref2.theme;
  return _react.default.createElement("div", {
    className: "vn-stepper"
  }, steps.map(function (step, index) {
    return _react.default.createElement(Step, {
      main: true,
      onChange: function onChange() {
        return _onChange(index, undefined);
      },
      step: step,
      key: step.key || index,
      theme: theme
    }, step.steps && step.steps.map(function (subStep, subIndex) {
      return _react.default.createElement(Step, {
        onChange: function onChange() {
          return _onChange(index, subIndex);
        },
        step: subStep,
        key: subStep.key || subIndex,
        theme: theme
      });
    }));
  }));
};

Stepper.propTypes = {
  onChange: _propTypes.default.func,
  steps: _propTypes.default.arrayOf(Step),
  theme: _propTypes.default.oneOf(['dark', 'light'])
};
Stepper.defaultProps = {
  onChange: function onChange() {},
  steps: undefined,
  theme: 'light'
};
Stepper.displayName = 'Stepper';
var _default = Stepper;
exports.default = _default;
